import _ from 'lodash';

export const paginate = (
  items: any[],
  pageNumber: number,
  pageSize: number
) => {
  const startIndex = (pageNumber - 1) * pageSize;
  return _(items)
    .slice(startIndex)
    .take(pageSize)
    .value();
};

export const getPages = (itemsCount: number, pageSize: number): number[] => {
  let pages: number[] = [];
  for (let i = 0; i < Math.ceil(itemsCount / pageSize); i++) {
    pages.push(i + 1);
  }
  return pages;
};
